/* footer-animation JavaScript/jQuery */
jQuery(function( $ ) {

    $( '#site-footer .social-media-links a' ).on( 'mouseenter', function() {
        $( this ).animateCss( 'swing' );
    });

    // push footer to bottom on load of short pages
    function pushFooterDown() {
        let minHeight = $( window ).height()
            - $( '.navbar' ).outerHeight()
            - $( '#page-header' ).outerHeight()
            - $( '#site-footer' ).outerHeight();

        $( '#content' ).css( 'min-height', minHeight + 'px' );
    }

    pushFooterDown();

    $( '#site-footer' ).show();

    // TODO - underscore debounce?
    $( window ).on( 'resize', pushFooterDown );

});
